<template>
  <div>
    <b-modal id="modalEditUsersGroups" ref="modalEditUsersGroups" :title="$t('Group')" hide-footer @shown="shown">
      <div v-if="editItem">
        <b-form-group label-align="right" label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number"  v-model="editItem.group_id" aria-describedby="inputFeedbackId" :state="editItem.group_id > 0" :disabled="isEdit"/>
          <b-form-invalid-feedback id="inputFeedbackId">
            {{ $t('Enter ID') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.group_name" aria-describedby="inputFeedbackName" :state="editItem.group_name.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackName">
            {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-table sticky-header striped hover small v-if="isEdit"
          :items="usersItems"
          :fields="usersFields">
          <template v-slot:cell(actions)="row">
            <i @click.stop="ClickOnDeleteButton(row)" class="danger fa fa-trash-alt fa-lg"/>
          </template>
        </b-table>

        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditUsersGroups')"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null,
    isEdit: null
  },
  data () {
    return {
      deleteImage: require('@/assets/img/document_delete.png'),
      usersFields: [
        {key: 'user_id', label: this.$i18n.t('Customer ID'), sortable: true},
        {key: 'user_login', label: this.$i18n.t('Login'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions')}
      ]
    }
  },
  methods: {
    save () {
      if (!this.editItem.group_id) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('ID field is invalid'), 'Error')
        return
      }
      if (!this.editItem.group_name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Name field is invalid'), 'Error')
        return
      }

      this.editItem.group_id = Number(this.editItem.group_id)
      let response = this.isEdit
        ? this.$store.dispatch('Users/UPDATE_GROUPS', this.editItem)
        : this.$store.dispatch('Users/CREATE_GROUPS', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Users/GET_GROUPS')
          this.$refs.modalEditUsersGroups.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    shown () {
      if (this.isEdit) {
        this.$store.dispatch('Users/GET_GROUP_INFO', this.editItem.group_id)
      }
    },
    ClickOnDeleteButton (row) {
      let delUsers = {
        user_id: 0,
        group_id: 0
      }
      delUsers.group_id = this.editItem.group_id
      delUsers.user_id = row.item.user_id
      let response = this.$store.dispatch('Users/DELETE_USER_FROM_GROUPS', delUsers)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$store.dispatch('Users/GET_GROUP_INFO', this.editItem.group_id)
          this.$root.$emit('makeToasts')
        }
      })
    }
  },
  computed: {
    usersItems () {
      return this.$store.getters['Users/GROUPS_INFO'].group_users
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/groups/editModal.vue